/* eslint-disable react-hooks/exhaustive-deps */
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";
import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import fetchData from "../../../utils/api";
import { ChevronDown, ChevronUp, CircleX } from "lucide-react";
import { Separator } from "../../../components/ui/separator";
import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import { Config } from "../../../utils/config";
import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";
import { toast } from "../../../components/ui/use-toast";
import CartFooter from "./CartFooter";
import React from "react";
import { RadioGroup, RadioGroupItem } from "../../../components/ui/radio-group";
import { useTranslation } from "react-i18next";
import ErrorBoundary from "../../../ErrorBoundary";

export default function CardListItems({
  orderingMethod,
  cartList,
  id,
  authToken,
  handleCartList,
  setCartTotal,
  couponCodeValue,
  couponCode,
  isCouponCode,
  setIsCouponCode,
  isValidCoupon,
  couponData,
  couponDiscount,
  setCouponCodeValue,
  subtotal,
  restaurantDetail,
  taxLabel,
  serviceFeesLabel,
  total,
  deliveryFeesTax,
  deliveryFees,
  minimumOrderAmount,
  cartId,
  isOnlinePayment,
  setIsOnlinePayment,
  paymentDetails,
  setPaymentDetails,
  setIsPlaceOrder,
  setIsHeader,
  isTip,
  setIsTip,
  tipAmount,
  setTipAmount,
  totalTipAmount,
  tipTaxFees,
  roundOff,
}) {
  const { t } = useTranslation();
  const [isCouponCodeRemove, setIsCouponCodeRemove] = React.useState(false);
  const [couponCodeData, setCouponCodeData] = React.useState([]);
  const [isNotAvailable, setIsNotAvailable] = React.useState(false);

  const handleCartDelete = async ({ cartItem }) => {
    try {
      const cachedCart = localStorage.getItem("cart");
      const body: any = {
        cart_id: cachedCart,
        values: cartItem,
      };
      const res = await fetchData({
        url: "cart/delete",
        method: "POST",
        body,
        token: authToken,
      });
      if (res.status_code === 200) {
        handleCartList();
        setCartTotal(res.data.cart_total);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleCheckCouponCode = async () => {
    try {
      const cachedCart = localStorage.getItem("cart");
      const body: any = {
        cart_id: cachedCart,
        coupon_code: couponCodeValue,
      };
      const res = await fetchData({
        url: "cart/coupon-code",
        method: "POST",
        body,
        token: authToken,
      });

      if (res.status_code === 200) {
        if (res.message === "cart.add_coupon_code.error") {
          toast({
            variant: "destructive",
            title: t(res.message),
          });
        } else {
          handleCartList();
          toast({
            title: `${t(res.message)} ${res.data}`,
          });
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleRemoveCoupon = async () => {
    try {
      const cachedCart = localStorage.getItem("cart");
      const body: any = {
        cart_id: cachedCart,
        coupon_code: couponCodeValue,
      };
      const res = await fetchData({
        url: "cart/remove-coupon-code",
        method: "POST",
        body,
        token: authToken,
      });

      if (res.status_code === 200) {
        handleCartList();
        setIsCouponCodeRemove(true);
        setTimeout(() => {
          setIsCouponCodeRemove(false);
        }, 2000);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleFetchCouponCodes = async () => {
    try {
      const res = await fetchData({
        url: "cart/coupon-codes",
        method: "POST",
        token: authToken,
      });
      if (res.status_code === 200) {
        setCouponCodeData(res.data);
        return res.data;
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  React.useEffect(() => {
    handleFetchCouponCodes();
  }, []);

  const columns: ColumnDef<any>[] = [
    {
      accessorKey: "quantity",
      header: t("cart.table.quantity"),
      cell: ({ row }) => {
        return (
          <div className="flex gap-10 capitalize items-center font-bold">
            {row.getValue("quantity")}
          </div>
        );
      },
    },
    {
      accessorKey: "name",
      header: t("cart.table.item"),
      cell: ({ row }) => {
        const rowValue = row.original;

        if (
          rowValue.countTotal[
            cartList?.orderingMethod?.ordering_method === "dine_in"
              ? "in_restaurant"
              : cartList?.orderingMethod?.ordering_method || "delivery"
          ] === 0
        ) {
          rowValue.availability = "not_available";
          setIsNotAvailable(true);
        } else {
          setIsNotAvailable(false);
        }
        if (
          rowValue.cart_total.pricing[
            cartList?.orderingMethod?.ordering_method === "dine_in"
              ? "in_restaurant"
              : cartList?.orderingMethod?.ordering_method || "delivery"
          ] === 0
        ) {
          rowValue.availability = "not_available";
          setIsNotAvailable(true);
        } else {
          setIsNotAvailable(false);
        }
        if (rowValue.choices_and_addons.length > 0) {
          // rowValue.cart_total.choices_and_addons.map((item, index) => {
          //   if (
          //     item.pricing[
          //       cartList?.orderingMethod?.ordering_method === "dine_in"
          //         ? "in_restaurant"
          //         : cartList?.orderingMethod?.ordering_method || "delivery"
          //     ] === 0
          //   ) {
          //     rowValue.availability = "not_available";
          //     setIsNotAvailable(true);
          //   }
          // });
        }

        return (
          <div>
            <div className="flex gap-1 items-center font-bold">
              {row.getValue("name")}{" "}
              {rowValue.availability !== "in_stock" &&
                rowValue.availability === "out_of_stock" && (
                  <Badge variant="destructive">{t("out_of_stock")}</Badge>
                )}
              {rowValue.availability !== "in_stock" &&
                rowValue.availability === "not_available" && (
                  <Badge variant="destructive">{t("not_available")}</Badge>
                )}
            </div>
            {rowValue.size !== "" && (
              <div className="flex space-y-1 items-center">{rowValue.size}</div>
            )}
            {rowValue.choices_and_addons.length > 0 && (
              <div className="grid gap-1 items-center">
                {rowValue.choices_and_addons.map((item, index) => (
                  <div key={index} className="flex">
                    {item}
                  </div>
                ))}
              </div>
            )}
            {rowValue?.is_instructions === true &&
              rowValue?.instructions !== "" && (
                <div className="mt-2">
                  <div className="flex space-y-1 items-center font-bold">
                    {rowValue.instructions}
                  </div>
                </div>
              )}
          </div>
        );
      },
    },
    {
      accessorKey: "price",
      header: t("cart.table.price"),

      cell: ({ row }) => {
        const rowValue = row.original;
        // const isMealBundleItem = couponData?.details?.eligible_items?.some(
        //   (category) =>
        //     category.items.some(
        //       (item) =>
        //         item.name === rowValue.name ||
        //         (item.sizes &&
        //           item.sizes.some((size) => size.id === rowValue.size))
        //     )
        // );

        // if (isMealBundleItem && couponData?.type === "meal_bundle") {
        //   return null;
        // }

        return (
          <div>
            <div className="flex gap-1 capitalize items-center font-bold">
              {restaurantDetail?.currencyDetails?.symbol}{" "}
              {/* {rowValue.countTotal[
                cartList?.orderingMethod?.ordering_method === "dine_in"
                  ? "in_restaurant"
                  : cartList?.orderingMethod?.ordering_method || "delivery"
              ]?.toFixed(2)}{" "} */}
              {rowValue.cart_total.pricing[
                cartList?.orderingMethod?.ordering_method === "dine_in"
                  ? "in_restaurant"
                  : cartList?.orderingMethod?.ordering_method || "delivery"
              ]?.toFixed(2)}{" "}
            </div>
            {rowValue.size !== "" && (
              <div className="flex space-y-1 capitalize items-center">
                {restaurantDetail?.currencyDetails?.symbol}{" "}
                {rowValue.cart_total.pricing[
                  cartList?.orderingMethod?.ordering_method === "dine_in"
                    ? "in_restaurant"
                    : cartList?.orderingMethod?.ordering_method || "delivery"
                ]?.toFixed(2)}{" "}
              </div>
            )}
            {rowValue.choices_and_addons.length > 0 && (
              <div className="grid gap-1 capitalize items-center">
                {rowValue.cart_total.choices_and_addons.map((item, index) => {
                  const pricing =
                    item.pricing[
                      cartList?.orderingMethod?.ordering_method === "dine_in"
                        ? "in_restaurant"
                        : cartList?.orderingMethod?.ordering_method ||
                          "delivery"
                    ];

                  return (
                    <div key={index} className="flex">
                      {pricing === 0 ? (
                        <div>-</div>
                      ) : (
                        <div>
                          {restaurantDetail?.currencyDetails?.symbol}{" "}
                          {pricing?.toFixed(2)}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      },
    },
    {
      accessorKey: "total",
      header: t("cart.table.total"),
      cell: ({ row }) => {
        const rowValue = row.original;

        return (
          <div>
            <div className="flex gap-10 capitalize items-center font-bold">
              {restaurantDetail?.currencyDetails?.symbol}{" "}
              {rowValue.countTotal[
                cartList?.orderingMethod?.ordering_method === "dine_in"
                  ? "in_restaurant"
                  : cartList?.orderingMethod?.ordering_method || "delivery"
              ]?.toFixed(2)}{" "}
            </div>
            {/* {rowValue.size !== "" && (
              <div className="flex space-y-1 capitalize items-center">
                {restaurantDetail?.currencyDetails?.symbol}{" "}
                {
                  rowValue.cart_total.pricing[
                    cartList?.orderingMethod === "dine_in"
                      ? "in_restaurant"
                      : cartList?.orderingMethod
                  ]
                }
              </div>
            )} */}
          </div>
        );
      },
    },
    {
      id: "actions",
      enableHiding: false,
      cell: ({ row }) => {
        const rowData = row.original;
        return (
          <div className="flex gap-10 capitalize items-center ">
            <CircleX
              className="h-4 w-4 cursor-pointer"
              onClick={() => handleCartDelete({ cartItem: rowData })}
            />
          </div>
        );
      },
    },
  ];

  const table = useReactTable({
    data: cartList?.details ?? [],
    columns,
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
  });

  const handleAddTip = async () => {
    try {
      const cachedCart = localStorage.getItem("cart");
      const body: any = {
        cart_id: cachedCart,
        tip_amount: tipAmount,
      };
      const res = await fetchData({
        url: "cart/tip",
        method: "POST",
        body,
        token: authToken,
      });

      if (res.status_code === 200) {
        handleCartList();
        toast({
          title: `${t(res.message)}`,
        });
        setIsTip(false);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleRemoveTip = async () => {
    try {
      const cachedCart = localStorage.getItem("cart");
      const body: any = {
        cart_id: cachedCart,
        tip_amount: 0,
      };
      const res = await fetchData({
        url: "cart/tip",
        method: "POST",
        body,
        token: authToken,
      });

      if (res.status_code === 200) {
        handleCartList();
        toast({
          title: t("cart.add_tip.remove_success"),
        });
        setIsTip(false);
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  return (
    <ErrorBoundary>
      <div className="h-fit w-full p-4 bg-white rounded-lg space-y-4">
        {cartList?.orderingMethod?.ordering_method !== "table_reservation" ? (
          <div className="rounded-md border">
            <Table>
              <TableHeader>
                {table.getHeaderGroups().map((headerGroup) => (
                  <TableRow key={headerGroup.id}>
                    {headerGroup.headers.map((header) => {
                      return (
                        <TableHead key={header.id}>
                          {header.isPlaceholder
                            ? null
                            : flexRender(
                                header.column.columnDef.header,
                                header.getContext()
                              )}
                        </TableHead>
                      );
                    })}
                  </TableRow>
                ))}
              </TableHeader>
              <TableBody>
                {table.getRowModel().rows?.length ? (
                  table.getRowModel().rows.map((row) => (
                    <TableRow
                      key={row.id}
                      data-state={row.getIsSelected() && "selected"}
                    >
                      {row.getVisibleCells().map((cell) => (
                        <TableCell key={cell.id}>
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      className="h-24 text-center text-gray-300"
                    >
                      <Badge className="px-4 py-2">{t("cart_empty")}</Badge>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <Separator />
            <div className="p-4 grid gap-4">
              {couponCode && (
                <div className="border-b ">
                  {!isValidCoupon && cartList?.details?.length > 0 && (
                    <a
                      className="font-bold text-sm cursor-pointer text-primary flex items-center gap-1 mb-2 "
                      onClick={() => setIsCouponCode(!isCouponCode)}
                    >
                      {t("cart.add_coupon_code.title")}
                      {isCouponCode ? (
                        <ChevronUp className="size-5" />
                      ) : (
                        <ChevronDown className="size-5" />
                      )}
                    </a>
                  )}
                  {!isCouponCode ? (
                    <div>
                      {/* {isCouponCodeRemove && (
                      <p className="text-sm text-destructive">
                        Promo code removed
                      </p>
                    )} */}
                    </div>
                  ) : isValidCoupon && couponDiscount ? (
                    <>
                      <Card className="mb-4 p-3">
                        <CardHeader>
                          <div className="flex justify-between items-center">
                            <div className="flex justify-between">
                              {couponDiscount && (
                                <div>
                                  <p className="text-sm mb-2 text-[#00b259] font-semibold">
                                    Promo code applied
                                  </p>
                                  <CardTitle className="text-sm sm:text-sm font-bold mb-1 sm:mb-0">
                                    {couponCodeValue}
                                  </CardTitle>
                                  <div className="flex items-center gap-1">
                                    <CardContent className="font-bold text-sm sm:text-base">
                                      -
                                      {
                                        restaurantDetail?.currencyDetails
                                          ?.symbol
                                      }{" "}
                                      {couponDiscount?.discount}
                                    </CardContent>
                                    <CardContent className="text-sm sm:te">
                                      ({couponData?.name})
                                    </CardContent>
                                  </div>
                                </div>
                              )}
                            </div>
                            <Button
                              className="bg-transparent text-destructive hover:bg-transparent"
                              onClick={() => handleRemoveCoupon()}
                            >
                              Remove
                            </Button>
                          </div>
                        </CardHeader>
                        <Separator />
                        <CardContent className="pt-2">
                          <div>
                            <Label className="font-bold">
                              {t("cart.add_coupon_code.condition")}
                            </Label>
                          </div>
                          <div>
                            <Label>
                              {t("cart.add_coupon_code.only_once_in_cart")}
                            </Label>
                          </div>
                          {couponData?.details?.is_min_order === true && (
                            <div>
                              <Label>
                                {t("cart.add_coupon_code.sub_total")}
                              </Label>
                              <Label>
                                {restaurantDetail?.currencyDetails?.symbol}{" "}
                                {Number(couponData?.details?.min_order).toFixed(
                                  2
                                )}
                              </Label>
                            </div>
                          )}
                          {couponData?.details?.client_type !==
                            "any_client_new_or_returning" && (
                            <div>
                              <Label>
                                {t("cart.add_coupon_code.client_type")}
                              </Label>
                              <Label>
                                {couponData?.details?.client_type ===
                                "only_new_clients"
                                  ? t("cart.add_coupon_code.new")
                                  : t("cart.add_coupon_code.returning")}
                              </Label>
                            </div>
                          )}
                          {couponData?.details?.is_order_type !==
                            "any_type" && (
                            <div>
                              <Label>
                                {t("cart.add_coupon_code.order_type")}
                              </Label>
                              <Label>
                                {Config.env.app.order_type_custom
                                  .filter((item) =>
                                    couponData?.details?.order_type.includes(
                                      item.value
                                    )
                                  )
                                  .map((item) => item.label)
                                  .join(", ")}
                              </Label>
                            </div>
                          )}
                          {couponDiscount?.discounted_items &&
                            couponDiscount?.discounted_items.length > 0 &&
                            couponDiscount?.discounted_items.map((item) => (
                              <div key={item.menu_item_name}>
                                <div>
                                  <Label className="font-bold">
                                    {item.menu_item_name}
                                  </Label>
                                </div>
                                {Object.entries(item as any).map(
                                  ([key, value]): any => {
                                    // Skip menu_item_name as it's already displayed
                                    if (key === "menu_item_name") return null;

                                    // Handle array values (like Sauces)
                                    if (Array.isArray(value)) {
                                      return value.map((val, index) => (
                                        <div key={`${key}-${index}`}>
                                          <Label>
                                            {key}: {val}
                                          </Label>
                                        </div>
                                      ));
                                    }

                                    // Handle single values (like size)
                                    return (
                                      <div key={key}>
                                        <Label>
                                          {t(key)}: {value as any}
                                        </Label>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ))}
                        </CardContent>
                      </Card>
                    </>
                  ) : (
                    <div className="grid gap-2">
                      <div className="flex gap-2 mb-4">
                        <div className="w-full">
                          <Input
                            id="coupon_code"
                            value={couponCodeValue}
                            onChange={(e) => {
                              setCouponCodeValue(e.target.value);
                            }}
                          />
                        </div>
                        <div className="col-span-2">
                          <Button
                            className="w-full"
                            disabled={couponCodeValue === ""}
                            onClick={() => handleCheckCouponCode()}
                          >
                            {t("cart.add_coupon_code.apply")}
                          </Button>
                        </div>
                      </div>
                      <div>
                        {couponCodeData && couponCodeData.length > 0 && (
                          <RadioGroup
                            className={`space-y-4  ${
                              couponCodeData && couponCodeData.length > 0
                                ? "max-h-[270px] h-fit"
                                : ""
                            }  overflow-y-auto no-scrollbar`}
                            value={couponCodeValue}
                            onValueChange={(e: any) => {
                              setCouponCodeValue(e);
                            }}
                          >
                            {couponCodeData &&
                              couponCodeData.length > 0 &&
                              couponCodeData.map((item: any, index) => (
                                <Label htmlFor={item.value} key={index}>
                                  <RadioGroupItem
                                    value={item.value}
                                    id={item.value}
                                    className="peer sr-only"
                                    aria-label={item.value}
                                  />

                                  <Label
                                    htmlFor={item.value}
                                    className="flex flex-col rounded-md border-2 border-muted bg-transparent p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
                                  >
                                    <div className="grid gap-2">
                                      <Label
                                        htmlFor={item.value}
                                        className="flex justify-start font-bold text-md"
                                      >
                                        {t(item.label)}
                                      </Label>
                                      <Label htmlFor={item.value}>
                                        {item.value}
                                      </Label>
                                    </div>
                                  </Label>
                                </Label>
                              ))}
                          </RadioGroup>
                        )}
                      </div>
                      <Separator />
                    </div>
                  )}
                </div>
              )}
              {cartList?.details?.length > 0 && (
                <div className="border-b ">
                  <a
                    className="font-bold text-sm cursor-pointer text-primary flex items-center gap-1 mb-2 "
                    onClick={() => setIsTip(!isTip)}
                  >
                    {t("cart.add_tip.title")}
                    {isTip ? (
                      <ChevronUp className="size-5" />
                    ) : (
                      <ChevronDown className="size-5" />
                    )}
                  </a>

                  {isTip && (
                    <div className="grid gap-2">
                      <div className="flex gap-4 mb-4 items-center">
                        <div className="w-full relative">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm">
                            {restaurantDetail?.currencyDetails?.symbol}
                          </span>
                          <Input
                            type="number"
                            min={0}
                            className={`${
                              restaurantDetail?.currencyDetails?.symbol ===
                              "CHF"
                                ? "pl-11"
                                : "pl-6"
                            }`}
                            id="tip"
                            value={Number(tipAmount)}
                            onChange={(e) => {
                              setTipAmount(e.target.value);
                            }}
                          />
                        </div>
                        {tipAmount > 0 && (
                          <div className="col-span-2">
                            <CircleX
                              className="h-5 w-5 cursor-pointer"
                              onClick={() => {
                                setTipAmount(0);
                                handleRemoveTip();
                              }}
                            />
                          </div>
                        )}

                        <div className="col-span-2">
                          <Button
                            disabled={tipAmount === 0 || tipAmount === ""}
                            className="w-full"
                            onClick={() => handleAddTip()}
                          >
                            {t("cart.add_tip.apply")}
                          </Button>
                        </div>
                      </div>
                      <Separator />
                    </div>
                  )}
                </div>
              )}

              <div className="flex justify-between">
                <Label className="text-muted-foreground">
                  {t("cart.table.sub_total")}
                </Label>
                <Label>
                  {restaurantDetail?.currencyDetails?.symbol}{" "}
                  {subtotal?.toFixed(2) ?? 0}
                </Label>
              </div>

              {cartList.orderingMethod?.ordering_method === "delivery" && (
                <div className="grid gap-4">
                  <div className="flex justify-between">
                    <Label className="text-muted-foreground">
                      {t("cart.table.delivery_fees").replace(
                        "{amount}",
                        restaurantDetail?.taxation?.tax_delivery_fee
                      )}
                    </Label>
                    <Label>
                      {restaurantDetail?.currencyDetails?.symbol}{" "}
                      {Number(deliveryFees?.toFixed(2))}
                      {/* {Number(deliveryFees?.toFixed(2)) +
                      Number(deliveryFeesTax?.toFixed(2))} */}
                      {/* {(deliveryFees + deliveryFeesTax).toFixed(2)} */}
                    </Label>
                  </div>
                  {/* <div className="flex justify-between">
                  <Label className="text-muted-foreground">
                    {t("cart.table.delivery_fees_tax")} (
                    {Number(restaurantDetail?.taxation?.tax_delivery_fee)}%)
                  </Label>
                  <Label>
                    {restaurantDetail?.currencyDetails?.symbol}{" "}
                    {deliveryFeesTax?.toFixed(2)}
                  </Label>
                </div> */}
                </div>
              )}

              {cartList?.details?.length > 0 &&
                ((serviceFeesLabel && serviceFeesLabel.length > 0) ||
                  totalTipAmount > 0 ||
                  taxLabel?.length > 0) && (
                  <div className="flex justify-between">
                    <div className="grid gap-4 justify-start">
                      {taxLabel?.map((item, index) => (
                        <Label
                          key={index}
                          className="text-left text-muted-foreground"
                        >
                          {`${restaurantDetail.taxation.name_of_tax} - ${item.name}`}{" "}
                          (
                          {restaurantDetail?.taxation?.sales_tax ===
                          "menu_prices_already_include_taxes"
                            ? `${item.tax}% ${t("included")}`
                            : `${item.tax}%`}
                          )
                        </Label>
                      ))}

                      {serviceFeesLabel &&
                        serviceFeesLabel.length > 0 &&
                        serviceFeesLabel?.map((item, index) => (
                          <Label
                            key={index}
                            className="text-left text-muted-foreground"
                          >
                            {item.name} ({item.tax})
                          </Label>
                        ))}
                      {totalTipAmount > 0 && (
                        <Label className="text-left text-muted-foreground">
                          {t("cart.table.tips")}
                        </Label>
                      )}
                    </div>
                    <div className="grid gap-4 justify-end">
                      {taxLabel?.map((item, index) => (
                        <Label key={index} className="text-right">
                          {restaurantDetail?.currencyDetails?.symbol}{" "}
                          {item.totalTax.toFixed(2)}
                        </Label>
                      ))}
                      {serviceFeesLabel &&
                        serviceFeesLabel.length > 0 &&
                        serviceFeesLabel?.map((item, index) => (
                          <Label key={index} className="text-right">
                            {restaurantDetail?.currencyDetails?.symbol}{" "}
                            {item.totalTax.toFixed(2)}
                          </Label>
                        ))}
                      {totalTipAmount > 0 && (
                        <Label className="text-right">
                          {restaurantDetail?.currencyDetails?.symbol}{" "}
                          {totalTipAmount.toFixed(2)}
                        </Label>
                      )}
                    </div>
                  </div>
                )}

              {Number(roundOff) !== 0 && (
                <div className="flex justify-between">
                  <Label className="text-muted-foreground">
                    {t("cart.table.round_off")}
                  </Label>
                  <Label>
                    {restaurantDetail?.currencyDetails?.symbol} {roundOff ?? 0}
                  </Label>
                </div>
              )}

              <div className="flex justify-between">
                <Label className="font-bold text-lg">
                  {t("cart.table.total")}
                </Label>
                <Label className="font-bold text-lg">
                  {restaurantDetail?.currencyDetails?.symbol} {total ?? 0}
                </Label>
              </div>
              <div className="flex justify-center">
                {cartList.orderingMethod?.ordering_method === "delivery" &&
                  minimumOrderAmount > subtotal && (
                    <Label className="font-bold text-lg text-destructive">
                      {t("cart.table.minimum_order")}{" "}
                      {restaurantDetail?.currencyDetails?.symbol}{" "}
                      {minimumOrderAmount?.toFixed(2)}
                    </Label>
                  )}
                {cartList.orderingMethod?.ordering_method === "pickup" &&
                  restaurantDetail?.services?.is_min_pickup_amount &&
                  restaurantDetail?.services?.min_pickup_amount > subtotal && (
                    <Label className="font-bold text-lg text-destructive">
                      {t("cart.table.minimum_order")}{" "}
                      {restaurantDetail?.currencyDetails?.symbol}{" "}
                      {restaurantDetail?.services?.min_pickup_amount.toFixed(2)}
                    </Label>
                  )}
                {cartList?.orderingMethod?.ordering_method ===
                  "in_restaurant" && (
                  <Card>
                    <CardContent>
                      <Label>
                        {t("cart.ordering_method.table_reservation.label_1")}
                      </Label>
                      <Label>
                        {
                          restaurantDetail?.tableReservation
                            ?.when_guest_are_late
                        }
                      </Label>
                      <Label>
                        {t("cart.ordering_method.table_reservation.label_2")}
                      </Label>
                    </CardContent>
                  </Card>
                )}
              </div>
              <CartFooter
                total={total}
                cart_id={cartId}
                restaurant_id={id}
                authToken={authToken}
                isOnlinePayment={isOnlinePayment}
                setIsOnlinePayment={setIsOnlinePayment}
                paymentDetails={paymentDetails}
                setPaymentDetails={setPaymentDetails}
                cartList={cartList}
                setIsPlaceOrder={setIsPlaceOrder}
                setIsHeader={setIsHeader}
                restaurantDetail={restaurantDetail}
                minimumOrderAmount={minimumOrderAmount}
                subtotal={subtotal}
                isNotAvailable={isNotAvailable}
              />
            </div>
          </div>
        ) : (
          <div className="text-center">
            <Card>
              <Label>
                {t("cart.ordering_method.table_reservation.label_1")}
              </Label>
              <Label>
                {restaurantDetail?.tableReservation?.when_guest_are_late}
              </Label>
              <Label>
                {t("cart.ordering_method.table_reservation.label_2")}
              </Label>
              <CartFooter
                total={total}
                cart_id={cartId}
                restaurant_id={id}
                authToken={authToken}
                isOnlinePayment={isOnlinePayment}
                setIsOnlinePayment={setIsOnlinePayment}
                paymentDetails={paymentDetails}
                setPaymentDetails={setPaymentDetails}
                cartList={cartList}
                setIsPlaceOrder={setIsPlaceOrder}
                setIsHeader={setIsHeader}
                restaurantDetail={restaurantDetail}
                minimumOrderAmount={minimumOrderAmount}
                subtotal={subtotal}
                isNotAvailable={isNotAvailable}
              />
            </Card>
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
}
